var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"div",staticClass:"  w-100 h-100 position-fixed overlay-frosted",staticStyle:{"left":"0","top":"0","z-index":"150","background-color":"inherit !important"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }